import { ActiveModelSerializer } from 'active-model-adapter';
import { ModelSchema } from 'ember-data';
import { ModelRegistry } from 'ember-data/model';

export default class SqlImportDatabaseSerializer extends ActiveModelSerializer {
  isNewSerializerAPI = true;

  normalize(modelClass: ModelSchema<keyof ModelRegistry>, hash: Record<string, any>, prop?: string) {
    // The backend sets name to 'cio_draft' when creating a new draft. We do not want to
    // display this at all so we reset it to empty string.
    if (hash.name === 'cio_draft') {
      hash.name = '';
    }
    return super.normalize(modelClass, hash, prop);
  }
}
